import { getSectionId } from '../utils/shopify-utils.js';

//chrom console: -url:https://au.timeresistance.com/cdn/shopifycloud/shopify-xr-js/v1.0/shopify-xr.en.js -url:chrome-extension://hdokiejnpimakedhajhdlcegeplioahd/background-redux-new.js -url:https://au.timeresistance.com/cdn/shopifycloud/media-analytics/v0.1/analytics.js -runtime.lastError -ERR_BLOCKED
class ReloadOnEvent extends HTMLElement {
    static sectionListeners = {};

    constructor() {
        super();
    }

    static registerSectionListener(sectionId, event, callback) {
        if (!this.sectionListeners[event]) {
            const listener = document.addEventListener(event, () => {
                this.handleEvent(event);
            });

            this.sectionListeners[event] = {
                listener,
                sections: {}
            };
        }

        const sectionListener = this.sectionListeners[event];

        if (!sectionListener.sections[sectionId]) {
            sectionListener.sections[sectionId] = [];
        }

        sectionListener.sections[sectionId].push(callback);
    }

    static async handleEvent(event) {
        const sectionIds = Object.keys(this.sectionListeners[event].sections);

        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionIds.join(','));

        const sectionJSON = await this.fetchSectionHTML(url);

        sectionIds.forEach((sectionId) => {
            const sectionListener = this.sectionListeners[event].sections[sectionId];

            sectionListener.forEach((callback) => {
                callback(sectionJSON[sectionId]);
            });
        });
    }

    static async fetchSectionHTML(url) {
        const sectionJSON = await fetch(url).then((res) => res.json());

        return sectionJSON;
    }

    static unregisterSectionListener(sectionId, event) {
        const sectionListener = this.sectionListeners[event];

        delete sectionListener.sections[sectionId];

        if (Object.keys(sectionListener.sections).length === 0) {
            document.removeEventListener(event, sectionListener.listener);
            delete this.sectionListeners[event];
        }
    }

    connectedCallback() {
        this.event = this.getAttribute('data-event');

        if (!this.id) {
            console.error('ReloadOnEvent: No id attribute found on element');
            return;
        }

        this.shopifySectionId = getSectionId(this);

        ReloadOnEvent.registerSectionListener(this.shopifySectionId, this.event, this.setNewHTML.bind(this));
    }

    disconnectedCallback() {
        ReloadOnEvent.unregisterSectionListener(this.sectionId, this.event);
    }

    async setNewHTML(html) {
        try {
            if (!html) {
                console.error(
                    'ReloadOnEvent setNewHTML: Fetched HTML is empty or null for section',
                    this.shopifySectionId
                );
                return;
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const fetchedSelf = doc.getElementById(this.id);

            if (!fetchedSelf) {
                console.error(
                    `ReloadOnEvent: Could not find "self" (<reload-on-event id="${this.id}">) element within the fetched section HTML.`
                );
            }

            this.innerHTML = fetchedSelf.innerHTML;
        } catch (error) {
            console.error('ReloadOnEvent setNewHTML: Error fetching or parsing HTML:', error);
        }
    }
}

customElements.define('reload-on-event', ReloadOnEvent);
